'use client';
import React from 'react';
import { withDefaultValues } from '../withDefaultValues';
export const Progress3Icon = withDefaultValues((props: React.SVGProps<SVGSVGElement>) => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><circle cx={12} cy={12} r={11} stroke="#DCE2E6" strokeWidth={2} /><path d="M12 4a8 8 0 110 16V4z" fill="#60707B" /></svg>);